import type { PatientCoverageResponse } from '@quromedical/models';

import { type AssertRule, compose, resolveConstant } from '../composer';

type MedicalAidParams = {
  coverage?: PatientCoverageResponse;
};

type AssertMedicalAidRule = AssertRule<MedicalAidParams>;

const assertHasMedicalAid: AssertMedicalAidRule = ({ coverage }) => {
  if (coverage) {
    return undefined;
  }
  return {
    type: 'error',
    messages: ['Patient does not have medical aid'],
  };
};

const defaultMedicalAidAssertions: AssertMedicalAidRule[] = [
  assertHasMedicalAid,
];

export const validateMedicalAidCoverage = compose({
  getRuleName: () => 'has-medical-aid',
  defaultAssertions: defaultMedicalAidAssertions,
  defaultResolver: resolveConstant<true>(true),
});
